import styled from 'styled-components';

const ColorPickerGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 1rem;

  label {
    width: 100%;
  }
`;

export default ColorPickerGroup;
